import "./styles.css";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";
import {
    collection,
    getDocs,
    query,
    where,
    orderBy,
} from "firebase/firestore";
import { db } from "../../utils/firebase";
import { useAuth } from "../../contexts/AuthContext";
import { useEffect, useState, useRef } from "react";
import "./styles.css";
import moment from "moment";

const IncomeBarChart = () => {
    const { currentUser } = useAuth();
    const [barData, setBarData] = useState([]);
    const dataFetchedRef = useRef(false);

    const transactionsCollectionRef = query(
        collection(db, "transactions"),
        where("uId", "==", currentUser.auth.currentUser.uid),
        orderBy("date", "desc")
    );

    let monthIncome;
    let monthlyIncomes = [];

    const setIncomeBarData = async () => {
        const data = await getDocs(transactionsCollectionRef);

        // get income transactions
        const incomes = data.docs.map((doc) => ({ ...doc.data(), id: doc.id })).filter(d => d.type === "Income");

        // get transactions for current month
        for (const inc of incomes) {
            if (moment().format('MMMM YYYY') === moment(inc.date).format('MMMM YYYY')) {
                //console.log(inc);
                if (monthlyIncomes.find(m => m.category === inc.category)) {
                    monthIncome = monthlyIncomes.find(m => m.category === inc.category);
                    monthIncome.amount += Number(inc.amount);
                } else {
                    monthIncome = {
                        category: inc.category,
                        amount: Number(inc.amount)
                    }
    
                    monthlyIncomes.push(monthIncome);
                }
            }
        }

        setBarData(monthlyIncomes);
    };

    useEffect(() => {
        // useEffect keeps running twice due to React.StrictMode being on
        // discussed here: https://stackoverflow.com/questions/60618844/react-hooks-useeffect-is-called-twice-even-if-an-empty-array-is-used-as-an-ar
        // temporary workaround: https://upmostly.com/tutorials/why-is-my-useeffect-hook-running-twice-in-react#:~:text=This%20is%20because%20outside%20of,your%20hook%20has%20been%20ran.
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        setIncomeBarData();
    }, []);

    return (
        <>
            <h2>Income per Category</h2>
            <h3><em>({moment().format('MMMM YYYY')})</em></h3>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <BarChart
                    width={500}
                    height={400}
                    data={barData}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="category" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="amount" fill="#198754" />
                </BarChart>
            </div>
        </>
      );
}

export { IncomeBarChart };